import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import "./Style.css";

export default function WarehouseModal({ show, closeModal, refreshPage, warehouseToEdit }) {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    status: "active",
  });
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (warehouseToEdit) {
      setFormData({
        name: warehouseToEdit.name || "",
        address: warehouseToEdit.address || "",
        status: warehouseToEdit.status || "active",
      });
    } else {
      resetForm();
    }
  }, [warehouseToEdit, show]);

  const resetForm = () => {
    setFormData({
      name: "",
      address: "",
      status: "active",
    });
    setValidationError({});
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setValidationError({});

    try {
      if (warehouseToEdit) {
        await axiosInstance.put(`/user/warehouses/update/${warehouseToEdit.id}`, formData);
        toast.success("Warehouse updated successfully");
      } else {
        await axiosInstance.post("/user/warehouses/create", formData);
        toast.success("Warehouse created successfully");
      }
      refreshPage();
      handleClose();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.data && error.response.data.data.errors) {
        setValidationError(error.response.data.data.errors);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-md">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{warehouseToEdit ? "Edit Warehouse" : "Create Warehouse"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Warehouse Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter warehouse name"
              required
            />
            {validationError.name && (
              <small className="text-danger">{validationError.name[0]}</small>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Enter address"
            />
            {validationError.address && (
              <small className="text-danger">{validationError.address[0]}</small>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select name="status" value={formData.status} onChange={handleChange}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
            {validationError.status && (
              <small className="text-danger">{validationError.status[0]}</small>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            style={{ backgroundColor: "#c4281b", color: "#fff", border: "none" }}
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : warehouseToEdit ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
